<template>
  <el-dialog
      :title="$t('text.resubmit')"
      :visible="show"
      @close="closeDialog"
      @open="init"
      :close-on-click-modal="false"
  >
    <div style="padding: 20px" align="center">
      {{ $t('message.selectedOrderSummary', {selected: value.length, amount: amount}) }}
    </div>

    <el-form :model="form" ref="form">

      <el-form-item v-if="ROLE_TYPE.isManager()"
                    :label="$t('text.paymentChannel')"
                    :label-width="formLabelWidth">
        <el-select v-model="form.channelId"
                   filterable
                   :placeholder="$t('message.chooseOne')">
<!--          未來待新增原渠道選項-->
<!--          <el-option :label="$t('option.all')"-->
<!--                     value=""/>-->
          <el-option v-for="item in payOption"
                     :key="item.channelId"
                     :label="item.channelName"
                     :value="item.channelId"/>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('text.googleAuthCode')"
                    :label-width="formLabelWidth"
                    prop="gAuthCode">
        <el-col :span="12">
          <el-input v-model="form.gAuthCode"
                    autocomplete="off"
                    :placeholder="$t('message.inputGoogleAuthCode')"/>
        </el-col>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="isButton">{{ $t('text.confirm') }}</el-button>
    </div>

  </el-dialog>
</template>

<script>
import {ROLE_TYPE} from "@/utils/Constant";


export default {
  name: "batchOrderResubmit",
  computed: {
    ROLE_TYPE() {
      return ROLE_TYPE
    }
  },
  props: {
    show: Boolean,
    value: Array,
    action: String,
    amount: Number
  },
  data() {
    return {
      dialogShow: this.show,
      isButton: true,
      isDisabled: false,
      payOption:[],
      form: {
        channelId: "",
        gAuthCode: ""
      },
      formLabelWidth: "200px",
      rules: {
        gAuthCode: [
          {require: true, message: this.$t('message.inputGoogleAuthCode'), trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    init() {
      this.$axios
          .get("/routeChannelInfo/selectByCondition", {params: {}})
          .then((res) => {
            res.data.map((item) => {
              if (item.productId === '120') {
                this.payOption.push(item);
              }
            });
          });
    },
    closeDialog() {
      this.form = {
        channelId: "",
        gAuthCode: ""
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false)
      this.payOption = [];
    },
    submit() {
      console.log(this.form);

      let prsOrderIds = this.value.join(',');

      this.$refs["form"].validate((valid) => {
        if (valid) {
          let params = {
            prsOrderIds: prsOrderIds,
            channelId: this.form.channelId,
            gAuthCode: this.form.gAuthCode
          };

          this.axios
              .post("/orderInterception/submit", params)
              .then((res) => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.prompt'),
                    message: res.msg,
                    type: "success"
                  });

                  this.$bus.$emit("refresh"); //通知刷新

                  this.closeDialog();
                } else {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg
                  });
                }
              });
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style scoped></style>